import { ElementDeclarationKind, ElementDeclarationSymbol } from "../constants.js";
/**
 * @internal scope: workspace
 */
export function createMarkupDeclaration(tagName, attributes, children) {
    return {
        [ElementDeclarationSymbol]: true,
        type: tagName.toLowerCase(),
        kind: ElementDeclarationKind.MarkupHTML,
        props: {},
        children,
        ref: undefined,
        key: undefined,
        listeners: undefined,
        renderMode: undefined,
        attributes,
    };
}
